import React, { useState, useEffect } from "react";
import Header from "../../../Common/Layout/Header";
import { useAuth } from "../../../Common/Configurations/AuthContext";

import AirlineOffers from "../../../Components/Advertisements/AirlineOffers";
import { useNavigate } from "react-router-dom";
import SearchFlightPanel4 from "../SearchFlightPanel/SearchFlightPanel4";

const SearchFlight4 = ({ mode, onNavigate, templateId, branding }) => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [currency, setCurrency] = useState(user?.currency);

  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            
              <div className="p-2">
            
              </div>
              <SearchFlightPanel4
           mode={mode} 
           onNavigate={onNavigate} 
           templateId={templateId} 
       />
           
            <AirlineOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFlight4;